"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalTheme = exports.setThemeToLocalStorage = exports.getThemeFromLocalStorage = void 0;
var react_1 = require("react");
var orange_1 = require("../theme/orange");
var theme_1 = __importDefault(require("../theme"));
var getThemeFromLocalStorage = function (theme) {
    if (theme === void 0) { theme = orange_1.orangeTheme; }
    if (window.localStorage.getItem("theme") !== null &&
        typeof window.localStorage.getItem("theme") === "string") {
        try {
            theme = __assign(__assign({ mode: "light", theme: Object.keys(theme_1.default).includes(window.location.hash.substr(1))
                    ? window.location.hash.substr(1)
                    : "all" }, orange_1.orangeTheme), JSON.parse(window.localStorage.getItem("theme") || ""));
        }
        catch (err) {
            return orange_1.orangeTheme;
        }
        return theme;
    }
    return theme;
};
exports.getThemeFromLocalStorage = getThemeFromLocalStorage;
var setThemeToLocalStorage = function (theme) {
    if (theme === void 0) { theme = orange_1.orangeTheme; }
    window.localStorage.setItem("theme", JSON.stringify(theme));
    window.dispatchEvent(new Event("themeChange"));
};
exports.setThemeToLocalStorage = setThemeToLocalStorage;
// Hook
function useLocalTheme(initialValue) {
    if (initialValue === void 0) { initialValue = orange_1.orangeTheme; }
    var _a = (0, react_1.useState)((0, exports.getThemeFromLocalStorage)(Object.keys(theme_1.default).includes(window.location.hash.substr(1))
        ? __assign(__assign({}, theme_1.default[window.location.hash.substr(1)]), { theme: window.location.hash.substr(1) }) : initialValue)), localTheme = _a[0], setLocalTheme = _a[1];
    var setTheme = (0, react_1.useCallback)(function (theme) {
        (0, exports.setThemeToLocalStorage)(theme);
    }, []);
    (0, react_1.useEffect)(function () {
        if (typeof window !== "undefined") {
            var listener_1 = function () {
                var value = (0, exports.getThemeFromLocalStorage)(initialValue);
                setLocalTheme(value);
            };
            window.addEventListener("themeChange", listener_1);
            window.addEventListener("storage", listener_1);
            return function () {
                window.removeEventListener("themeChange", listener_1);
                window.removeEventListener("storage", listener_1);
            };
        }
    }, []);
    return [localTheme, setTheme];
}
exports.useLocalTheme = useLocalTheme;
